<template>
    <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
        <div style="padding:0px;width:100%;">
            <div class="whiteBox dashboard_topic">
                <div class="portlet-title">
                    <i class="el-icon-d-arrow-right">&nbsp;</i>王朝线索跟进明细表
                </div>
                <div class="portlet-content">
                    <!-- 搜索区：参照厂端 clue-follow-details 搜索字段，去除经销商级联（单店登录） -->
                    <div class="filter-container" style="padding-top: 0px;">
                        <el-date-picker
                            size="mini"
                            v-model="listQuery.dateRange"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="客户创建开始日期"
                            end-placeholder="客户创建结束日期"
                            :clearable="false"
                            :picker-options="datePickerOption">
                        </el-date-picker>

                        <el-select
                            style="width: 110px"
                            size="mini"
                            clearable
                            placeholder="选择客户来源"
                            v-model="listQuery.fromType"
                            @clear="listQuery.fromType = null"
                            @change="() => { listQuery.source = []; listQuery.fromSource = []; }">
                            <el-option label="线上" :value="1"></el-option>
                            <el-option label="线下" :value="2"></el-option>
                        </el-select>

                        <el-select
                            v-if="listQuery.fromType === 1"
                            class="filter-item"
                            style="width: 150px"
                            size="mini"
                            filterable
                            clearable
                            multiple
                            collapse-tags
                            v-model="listQuery.source"
                            placeholder="选择渠道">
                            <el-option
                                v-for="item in importSources"
                                :key="item.dataName"
                                :label="item.dataDisplay"
                                :value="item.dataName">
                            </el-option>
                        </el-select>

                        <el-select
                            v-if="listQuery.fromType === 2"
                            class="filter-item"
                            style="width: 150px"
                            size="mini"
                            filterable
                            clearable
                            multiple
                            collapse-tags
                            v-model="listQuery.fromSource"
                            placeholder="选择线下来源">
                            <el-option
                                v-for="item in customerFromSources"
                                :key="item.dataValue"
                                :label="item.dataDisplay"
                                :value="item.dataValue">
                            </el-option>
                        </el-select>

                        <el-input
                            class="filter-item"
                            style="width: 150px"
                            size="mini"
                            v-model="listQuery.key"
                            placeholder="手机号或微信号"
                            clearable
                            @clear="doSearch">
                        </el-input>

                        <el-button class="filter-item" size="mini" type="info" icon="el-icon-search" @click="listQuery.page = 1; doSearch()">查询</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-refresh" @click="doReset">重置</el-button>
                        <el-button class="filter-item" size="mini" icon="el-icon-download" @click="doExport">导出</el-button>
                    </div>

                    <el-table :data="list" stripe id="table" v-loading="listLoading" :max-height="530">
                        <el-table-column prop="id" label="线索ID" width="85">
                            <template slot-scope="scope">{{ scope.row.id || '' }}</template>
                        </el-table-column>
                        <el-table-column prop="mobile" label="手机号" width="110">
                        </el-table-column>
                        <el-table-column prop="wechatId" label="微信号" min-width="100">
                        </el-table-column>
                        <el-table-column prop="source" label="线索来源渠道" min-width="120">
                        </el-table-column>
                        <el-table-column prop="dealerName" label="系统经销商名称" min-width="130">
                        </el-table-column>
                        <el-table-column prop="dealerCode" label="经销商编码" min-width="100">
                        </el-table-column>
                        <el-table-column prop="clueCreatedTime" label="线索创建时间" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.clueCreatedTime ? parseTime(scope.row.clueCreatedTime, "{y}-{m}-{d} {h}:{i}:{s}") : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="customerCreatedTime" label="客户创建时间" width="150">
                            <template slot-scope="scope">
                                {{ scope.row.customerCreatedTime ? parseTime(scope.row.customerCreatedTime, "{y}-{m}-{d} {h}:{i}:{s}") : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="cleanSeconds" label="线索清洗时长" width="120">
                            <template slot="header" slot-scope="scope">
                                线索清洗时长
                                <el-popover placement="top-start" width="200" trigger="hover">
                                    <div>清洗时长为线上线索的首次清洗时长。</div>
                                    <div>清洗时长=线索下发到店时间-清洗首次结果时间。</div>
                                    <i class="fa fa-question-circle-o" aria-hidden="true" slot="reference"></i>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                {{ (scope.row.cleanSeconds === null || scope.row.cleanSeconds === undefined || scope.row.cleanSeconds === '') ? '--' : `${scope.row.cleanSeconds}s` }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="isCleanPass" label="是否清洗合格" width="110">
                            <template slot="header" slot-scope="scope">
                                是否清洗合格
                                <el-popover placement="top-start" width="300" trigger="hover">
                                    <div>对于不同时间内创建的线上线索，清洗合格规则如下：</div>
                                    <div>●创建时间范围大于等于00:00小于9:00，且关联客档的创建时间早于当日12:00的线索；</div>
                                    <div>●创建时间范围大于等于9:00小于18:00，且线索清洗时长小于等于15分钟的线索；</div>
                                    <div>●创建时间范围大于等于18:00小于20:00，且线索清洗时长小于等于30分钟的线索；</div>
                                    <div>●创建时间范围大于等于20:00小于24:00，且关联客档的创建时间早于次日12:00的线索。</div>
                                    <i class="fa fa-question-circle-o" aria-hidden="true" slot="reference"></i>
                                </el-popover>
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.isCleanPass || '--' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="首次跟进期间" align="center">
                            <el-table-column prop="firstFollowTime" label="跟进时间" width="150">
                                <template slot-scope="scope">{{ scope.row.firstFollowTime || '' }}</template>
                            </el-table-column>
                            <el-table-column prop="firstFollowType" label="跟进方式" width="100">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="二次跟进期间" align="center">
                            <el-table-column prop="secondFollowTime" label="跟进时间" width="150">
                                <template slot-scope="scope">{{ scope.row.secondFollowTime || '' }}</template>
                            </el-table-column>
                            <el-table-column prop="secondFollowType" label="跟进方式" width="100">
                            </el-table-column>
                        </el-table-column>
                        <el-table-column label="三次跟进期间" align="center">
                            <el-table-column prop="thirdFollowTime" label="跟进时间" width="150">
                                <template slot-scope="scope">{{ scope.row.thirdFollowTime || '' }}</template>
                            </el-table-column>
                            <el-table-column prop="thirdFollowType" label="跟进方式" width="100">
                            </el-table-column>
                        </el-table-column>
                    </el-table>

                    <div class="pagination-container">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="listQuery.page" :page-sizes="[10,20,30,50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { parseTime } from '@/assets/js/util'
import dayjs from 'dayjs';

// 查询条件初始值（重置时恢复）：默认查当天
const initListQuery = {
    dateRange: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')], // 客户创建时间范围
    key: '', // 手机号或微信号
    fromType: null, // 来源类型：1线上 2线下，空为全部
    source: [], // 线上渠道（多选）
    fromSource: [], // 线下渠道（多选）
    page: 1,
    limit: 10,
};

export default {
    data() {
        return {
            parseTime,
            dealer: this.$common.getDealer(),
            importSources: [], // 线上线索一级来源字典
            customerFromSources: [], // 线下线索一级来源字典
            list: [],
            total: 0,
            listLoading: false,
            listQuery: Object.assign({}, initListQuery),
            datePickerOption: {
                firstDayOfWeek: 1,
            },
        };
    },
    mounted() {
        // 从基础数据字典中取线上/线下一级来源选项（字典缺失时降级为空数组）
        const baseInfo = this.$common.getBaseInfo() || {};
        this.importSources = baseInfo.importSources || [];
        this.customerFromSources = baseInfo.customerFromSources || [];
        this.doSearch();
    },
    methods: {
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.doSearch();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.doSearch();
        },
        doSearch() {
            // 边界1：时间范围为空时不发起请求
            if (!this.listQuery.dateRange || this.listQuery.dateRange.length !== 2) {
                this.$message.warning('为保证数据查询准确，客户创建时间必选一个时间范围。');
                return;
            }
            this.listLoading = true;
            this.list = [];
            this.$httpAuth
                .post("/v2/v2DealerReportRpc/customerFollowEs", {
                    ...this.getParams(),
                    pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
                    pageCount: this.listQuery.limit,
                    isExport: false,
                })
                .then((response) => {
                    // 边界2：接口无数据时兜底为空列表，避免表格报错
                    const data = response.data || {};
                    this.list = data.data || [];
                    this.total = data.total || 0;
                    this.listLoading = false;
                })
                .catch(() => {
                    // 边界3：请求异常时关闭 loading 并置空列表
                    this.listLoading = false;
                    this.list = [];
                    this.total = 0;
                });
        },
        doReset() {
            this.list = [];
            this.total = 0;
            this.listLoading = false;
            this.listQuery = Object.assign({}, initListQuery);
            this.doSearch();
        },
        doExport() {
            if (!this.listQuery.dateRange || this.listQuery.dateRange.length !== 2) {
                this.$message.warning('为保证数据查询准确，客户创建时间必选一个时间范围。');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: '正在导出中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$httpAuth
                .post("/v2/v2DealerReportRpc/customerFollowEs", { ...this.getParams(), isExport: true })
                .then((response) => {
                    const { File, total } = response.data
                    if (total > 2000) {
                        this.$message({
                            customClass: 'export-message',
                            dangerouslyUseHTMLString: true,
                            message: '<div>应安全要求，一次性最多只能导出2000条数据</div>',
                            duration: 2000
                        });
                    }
                    setTimeout(() => {
                        loading.close()
                        let a = document.createElement('a');
                        a.href = File;
                        a.click();
                    }, 1000);
                })
                .catch(() => {
                    loading.close()
                });
        },
        getParams() {
            const { dateRange, key, fromType, source, fromSource } = this.listQuery;
            // 时间转换为 00:00:00 ~ 23:59:59 的秒级时间戳；范围为空时传 null
            const dateStart = dateRange && dateRange.length === 2
                ? dayjs(`${dateRange[0]} 00:00:00`).unix()
                : null;
            const dateEnd = dateRange && dateRange.length === 2
                ? dayjs(`${dateRange[1]} 23:59:59`).unix()
                : null;
            return {
                dealerId: this.dealer.dealerId,
                key, // 手机号或微信号
                dateStart, // 客户创建开始时间
                dateEnd, // 客户创建结束时间
                fromType, // 来源类型：1线上 2线下，空为全部
                onlineSource: source.toString(), // 线上渠道，多个逗号分隔
                fromSource: fromSource.toString(), // 线下渠道，多个逗号分隔
            };
        },
    },
};
</script>

<style>

</style>
